module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "aftermarket"
  }, [_c('navbar'), _vm._v(" "), _c('div', {
    staticClass: "box-header"
  }, [_c('h1', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.$t('Order_return_exchange_type1')) + " / " + _vm._s(_vm.$t('Order_return_exchange_type2')))])]), _vm._v(" "), _c('div', {
    staticClass: "order-sn"
  }, [_vm._v(_vm._s(_vm.$t('user_center_order_order_num')) + ": "), _c('span', [_vm._v(_vm._s(_vm.$route.params.order_sn))])]), _vm._v(" "), _c('listing', {
    attrs: {
      "lists": _vm.orders
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.type === 'a') ? _c('div', {
    staticClass: "form-list"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('Order_return_exchange_type')))]), _vm._v(" "), _c('div', {
    staticClass: "form-control"
  }, [_c('label', {
    staticClass: "profile-radio",
    on: {
      "click": function($event) {
        _vm.setServiceType(1)
      }
    }
  }, [_c('span', {
    staticClass: "pro-radio",
    class: {
      'pro-radio-checked': _vm.serviceType == 1
    }
  }, [_c('span', {
    staticClass: "pro-radio-inner"
  }), _vm._v(" "), _c('input', {
    staticClass: "pro-radio-input",
    attrs: {
      "type": "radio"
    }
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Order_return_exchange_type1')))])]), _vm._v(" "), _c('label', {
    staticClass: "profile-radio",
    on: {
      "click": function($event) {
        _vm.setServiceType(2)
      }
    }
  }, [_c('span', {
    staticClass: "pro-radio",
    class: {
      'pro-radio-checked': _vm.serviceType == 2
    }
  }, [_c('span', {
    staticClass: "pro-radio-inner"
  }), _vm._v(" "), _c('input', {
    staticClass: "pro-radio-input",
    attrs: {
      "type": "radio"
    }
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Order_return_exchange_type2')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('Order_return_exchange_logistics_state')))]), _vm._v(" "), _c('div', {
    staticClass: "form-control"
  }, [_c('label', {
    staticClass: "profile-radio",
    on: {
      "click": function($event) {
        _vm.setExpressStatus(1)
      }
    }
  }, [_c('span', {
    staticClass: "pro-radio",
    class: {
      'pro-radio-checked': _vm.expressStatus == 1
    }
  }, [_c('span', {
    staticClass: "pro-radio-inner"
  }), _vm._v(" "), _c('input', {
    staticClass: "pro-radio-input",
    attrs: {
      "type": "radio"
    }
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Order_return_exchange_logistics_state_1')))])]), _vm._v(" "), _c('label', {
    staticClass: "profile-radio",
    on: {
      "click": function($event) {
        _vm.setExpressStatus(2)
      }
    }
  }, [_c('span', {
    staticClass: "pro-radio",
    class: {
      'pro-radio-checked': _vm.expressStatus == 2
    }
  }, [_c('span', {
    staticClass: "pro-radio-inner"
  }), _vm._v(" "), _c('input', {
    staticClass: "pro-radio-input",
    attrs: {
      "type": "radio"
    }
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Order_return_exchange_logistics_state_2')))])])])]), _vm._v(" "), (_vm.serviceType == 1) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('Order_return_exchange_amount')))]), _vm._v(" "), _c('div', {
    staticClass: "form-control"
  }, [_c('p', {
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.orders[0].goods_unit) + " " + _vm._s(_vm.orders[0].goods_price * _vm.orders[0].goods_num))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [(_vm.serviceType == 1) ? _c('label', [_vm._v(_vm._s(_vm.$t('Order_return_exchange_explain')))]) : _vm._e(), _vm._v(" "), (_vm.serviceType == 2) ? _c('label', [_vm._v(_vm._s(_vm.$t('Order_return_exchange_description')))]) : _vm._e(), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected),
      expression: "selected"
    }],
    staticClass: "return_select",
    attrs: {
      "id": "test"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.handleChange()
      }]
    }
  }, _vm._l((_vm.options), function(option, index) {
    return _c('option', {
      key: index,
      ref: "selected",
      refInFor: true,
      attrs: {
        "data": index
      },
      domProps: {
        "value": option.value
      }
    }, [_vm._v("\n                    " + _vm._s(option.text) + "\n                ")])
  }))]), _vm._v(" "), (_vm.other) ? _c('div', {
    staticClass: "form-group"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.explanation),
      expression: "explanation"
    }],
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "placeholder": _vm.$t('user_message_please_input_recharge'),
      "cols": "60",
      "rows": "5"
    },
    domProps: {
      "value": (_vm.explanation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.explanation = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('return_tips_title')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('return_tips_content')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-submit"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-big",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.$t('Submit_btn')))])])]) : (_vm.type === 'b') ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('Order_return_exchange_logistics_state')) + ":")]), _vm._v(" "), _c('div', {
    staticClass: "form-control"
  }, [_c('p', [_vm._v(_vm._s(_vm.typeName))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('Order_return_exchange_amount')) + "：")]), _vm._v(" "), _c('div', {
    staticClass: "form-control"
  }, [_c('p', {
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.orders[0].goods_unit) + _vm._s(_vm.orders[0].goods_price * _vm.orders[0].goods_num))])])]), _vm._v(" "), (_vm.serviceType == 1) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('Order_return_exchange_explain')) + "：")]), _vm._v(" "), _c('div', {
    staticClass: "form-control"
  }, [_c('p', [_vm._v(_vm._s(_vm.explanation || _vm.service_list.explanation))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('Order_return_exchange_status')) + "：")]), _vm._v(" "), _c('div', {
    staticClass: "form-control"
  }, [_c('span', [_vm._v(_vm._s(_vm.serviceStatusName))]), _vm._v(" "), (_vm.service_list.service_status != 9 || _vm.service_list.service_status != 3) ? _c('a', {
    staticClass: "text-primary",
    on: {
      "click": function($event) {
        _vm.openCanceled = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Order_return_exchange_Cancellation')))]) : _vm._e()])]), _vm._v(" "), _c('model', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "title": _vm.$t('Order_return_exchange_Cancellation')
    },
    on: {
      "on-ok": _vm.canceled
    },
    model: {
      value: (_vm.openCanceled),
      callback: function($$v) {
        _vm.openCanceled = $$v
      },
      expression: "openCanceled"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "20px"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('Order_return_exchange_Cancellation_tip')) + "\n            ")])])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5609e684","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MyDetails/Aftermarket.vue
// module id = 816
// module chunks = 0